import _ from "lodash";
import logger from "../utils/LoggerFrontend";
import Reflux from "reflux";
import Actions from "../Actions";
import { t } from "i18next";

export default class StatusStore extends Reflux.Store {
  constructor() {
    super();
    logger.debug("StatusStore:constructor", "called");

    this.state = {
      campaignMetrics: null,
      campaignList: null,
      campaignComments: null,
      campaignNotifications: null,
      adminCampaignList: null,
      allOrganizations: null, // used for the admin view
      campaignData: null,
      adsets: null,
      channelCampaigns: null,
      fbCommentsCampaign: undefined,
      isLoadingAdminCampaigns: false,
      campaignDataError: null,
      errorLoadingCampaigns: false,
      showAtsView: false,
      candidates: [],
      campaignManagers: []
    }; // <- set store's default state much like in React

    this.listenables = Actions;
  }
  onToggleAtsView() {
    this.setState({
      showAtsView: !this.state.showAtsView
    });
  }
  helperUpdateChannelCampaignMetrics(adsetMetrics = [], metricsField = "metrics") {
    const { channelCampaigns } = this.state;
    logger.log("StatusStore:helperUpdateChannelCampaignMetrics", "called", {
      adsetMetrics,
      channelCampaigns
    });
    if (!channelCampaigns?.length) {
      return logger.log(
        "StatusStore:helperUpdateChannelCampaignMetrics",
        "Nothing changed (1)",
        {}
      );
    }

    for (let adsetMetric of adsetMetrics) {
      if (!adsetMetric?.metrics) {
        continue;
      }

      const metricsVal = adsetMetric?.metrics || [];

      for (let { channelCampaignId, metrics: newMetrics } of metricsVal) {
        const channelCampaignToUpdate = _.find(channelCampaigns, { id: channelCampaignId });
        logger.log(
          "StatusStore:helperUpdateChannelCampaignMetrics",
          "found channel campaign to update",
          { channelCampaignToUpdate, channelCampaignId }
        );
        if (channelCampaignToUpdate) {
          channelCampaignToUpdate[metricsField] = _.merge(
            channelCampaignToUpdate[metricsField],
            newMetrics
          );
          channelCampaigns.push(channelCampaignToUpdate);
          this.setState({
            channelCampaigns: _.uniqBy(channelCampaigns, "id")
          });
          return logger.log(
            "StatusStore:helperUpdateChannelCampaignMetrics",
            "Changed single channelCampaign",
            {
              channelCampaigns
            }
          );
        }
      }
    }
  }
  onFetchAllComments() {
    this.setState({
      campaignComments: null
    });
  }
  onDeleteCommentCompleted(orgaId, campaignId, commentId) {
    let comments = this.state.campaignComments;
    if (comments) {
      logger.log("StatusStore:onDeleteCommentCompleted", "called..: ", { commentId });
      comments = _.filter(this.state.campaignComments, (comment) => {
        return comment.id !== commentId;
      });
    }

    this.setState({
      campaignComments: comments
    });
  }
  onStoreCommentWithoutEmailAndNotificationCompleted(
    orgaId,
    campaignId,
    comment,
    username,
    userrole,
    userId,
    commentId,
    meta
  ) {
    logger.debug("StatusStore:onStoreCommentWithoutEmailAndNotificationCompleted", "called..: ", {
      orgaId,
      campaignId,
      comment,
      username,
      userrole,
      userId,
      commentId,
      meta
    });
    this.onStoreCommentCompleted(
      orgaId,
      campaignId,
      comment,
      username,
      userrole,
      userId,
      commentId
    );
  }
  onStoreCommentCompleted(orgaId, campaignId, comment, username, userrole, userId, commentId) {
    logger.debug("StatusStore:onStoreCommentCompleted", "called..: ", {
      campaignId,
      comment,
      userrole
    });
    let comments = [];

    const commentData = {
      comment,
      userName: username,
      createDate: +new Date(),
      userrole,
      userId,
      id: commentId
    };

    if (!this.state.campaignComments) {
      comments = [commentData];
    } else {
      comments = this.state.campaignComments;
      comments.push(commentData);
    }

    logger.debug("StatusStore:onStoreCommentCompleted", "called..: ", {
      comments
    });

    this.setState({
      campaignComments: comments
    });
  }

  onFetchAllCommentsCompleted(comments) {
    logger.debug("StatusStore:onFetchAllCommentsCompleted", "called.. Nr of comments: ", {
      nrOfComments: comments && comments.length
    });
    this.setState({
      campaignComments: comments
    });
  }
  onGetCampaignNotificationsCompleted(notifications) {
    logger.debug(
      "StatusStore:ongetCampaignNotificationsCompleted",
      "called.. Nr of notifications: ",
      { nrOfNotis: notifications && notifications.length }
    );
    this.setState({
      campaignNotifications: notifications
    });
  }
  //TODO: Do we need this in the status store? Since its only used once ina view
  onLoadClickMetricsByDay() {
    this.setState({
      campaignMetrics: null
    });
  }
  //TODO: Do we need this in the status store? Since its only used once ina view
  onLoadClickMetricsByDayCompleted(metricsPerDay) {
    logger.debug("StatusStore:onLoadClickMetricsByDayCompleted", "called", { metricsPerDay });
    this.setState({
      campaignMetrics: {
        dailyClicksArr: metricsPerDay
      }
    });
  }

  onFetchAllActiveOrganisationsCompleted(organisations) {
    logger.debug("StatusStore:onFetchAllActiveOrganisationsCompleted", "called");

    this.setState({
      allOrganizations: organisations
    });
  }
  onFetchAllOrganisationsCompleted(organisations) {
    logger.debug("StatusStore:onFetchAllOrganisationsCompleted", "called..: ");

    this.setState({
      allOrganizations: organisations
    });
  }

  onFetchAllNotificationsCompleted(notifications) {
    logger.log("StatusStore:onFetchAllNotificationsCompleted", "called..: ", {
      notifications
    });

    this.setState({
      allNotifications: notifications
    });
  }

  //TODO: Updating the list here is too heavy
  onChangeCampaignData(orgaId, campaignId, field, value) {
    logger.debug("StatusStore:onChangeCampaignData", "called..: ", {
      orgaId,
      campaignId,
      field,
      value
    });

    if (this.state.campaignData && this.state.campaignData.id === campaignId) {
      this.state.campaignData[field] = value;
    }

    this.setState({
      campaignList: this.state.campaignList,
      campaignData: this.state.campaignData
    });
  }
  onChangeCampaignDataSingle(orgaId, campaignId, field, value) {
    const allCampaignData = this.state.campaignData;

    if (this.state.campaignData) {
      allCampaignData[field] = value;
    }

    this.setState({
      campaignData: allCampaignData
    });
  }
  onUpdateCampaignStatusCompleted(results) {
    logger.debug(
      "StatusStore:onUpdateCampaignStatusCompleted",
      "Checking if local state of campaign should be updated ",
      {
        results
      }
    );
    const campaignId = results?.meta?.campaignId;
    const newStatus = results?.meta?.newStatus;
    const { adminCampaignList = [], campaignData } = this.state;
    if (!campaignId) {
      return;
    }
    const campaignIndex = _.findIndex(adminCampaignList, {
      id: campaignId
    });

    if (campaignIndex >= 0) {
      adminCampaignList[campaignIndex].status = newStatus;
    }

    if (campaignData?.id === campaignId) {
      campaignData.status = newStatus;
    }

    this.setState({
      adminCampaignList,
      campaignData
    });
  }
  onClearSingleCampaignData() {
    this.setState({
      campaignData: null
    });
  }
  onLoadSingleCampaignCompleted(campaignData) {
    logger.log("StatusStore:onLoadSingleCampaignCompleted", "called..: ", {
      campaignId: campaignData && campaignData.id
    });
    this.setState({
      campaignData: campaignData,
      campaignDataError: null
    });
  }
  onGetAdsetsByCampaignIdCompleted(adsets) {
    logger.log("StatusStore:onGetAdsetsByCampaignIdCompleted", "called..: ", {
      adSetLen: adsets && adsets.length
    });
    adsets = _.orderBy(adsets, "flight", "desc");
    this.setState({
      adsets
    });
  }
  onGetAdsetsByCampaignIdFailed(error) {
    logger.log("error:StatusStore:onGetAdsetsByCampaignIdFailed", "called..: ", {
      error
    });
    this.setState({
      adsets: []
    });
  }
  onGetChannelCampaignsByCampaignIdCompleted(channelCampaigns) {
    logger.log("StatusStore:onGetChannelCampaignsByCampaignIdCompleted", "called..: ", {
      nrOfChannelCampaigns: channelCampaigns && channelCampaigns.length
    });
    this.setState({
      channelCampaigns
    });
  }
  onGetChannelSetsByCampaignIdFailed(error) {
    logger.log("error:StatusStore:onGetChannelSetsByCampaignIdFailed", "called..: ", {
      error
    });
    this.setState({
      channelSets: []
    });
  }
  onLoadCandidatesListCompleted(results) {
    logger.log("StatusStore:onLoadCandidatesListCompleted:completed", "called...");
    this.setState({ candidates: results });
  }
  onLoadSingleCampaignFailed(reason) {
    logger.log("error:StatusStore:onLoadSingleCampaignFailed", "called..: ", {
      reason
    });
    if (reason === "No user found") {
      return this.setState({
        campaignDataError: "No user found"
      });
    }
    this.setState({
      campaignDataError: "Kein Zugriff auf die Kampagne."
    });
  }
  onCreateCampaignAndSave() {
    this.setState({
      campaignList: null
    });
  }

  onLoadCampaignsCompleted(list) {
    logger.debug("StatusStore:onLoadCampaignsCompleted", "called... ", { list });
    this.setState({
      campaignList: list.payload || list || [],
      errorLoadingCampaigns: false
    });
  }
  onLoadCampaignsFailed(err) {
    logger.log("error:StatusStore:onLoadCampaignsFailed", "called... ", {
      err
    });
    this.setState({
      errorLoadingCampaigns: t("The campaign could not be loaded.")
    });
  }

  onLoadFilteredCampaignsCompleted(list) {
    logger.debug("StatusStore:onLoadFilteredCampaignsCompleted", "called... ", { list });
    const campaignList = list.payload || list || [];
    const nonAssistantCampaigns = campaignList.filter((campaign) => {
      return campaign.type !== "assistant";
    });

    this.setState({
      campaignList: nonAssistantCampaigns,
      errorLoadingCampaigns: false
    });
  }

  onLoadFilteredCampaignsFailed(err) {
    logger.log("error:StatusStore:onLoadFilteredCampaignsFailed", "called... ", {
      err
    });
    this.setState({
      errorLoadingCampaigns: t("The campaign could not be loaded.")
    });
  }

  onDeleteDraftCampaignCompleted({ campaignId, organizationId, removeCampaignById }) {
    const { campaignList = [] } = this.state;
    logger.log("StatusStore:onDeleteDraftCampaignCompleted", "called... ", {
      campaignId,
      organizationId,
      campaignList
    });
    Actions.addNotification(t("Draft campaign deleted"));

    removeCampaignById?.(campaignId); // filter out the ad assistant campaign

    this.setState({
      campaignList: campaignList.filter((campaign) => campaign.id !== campaignId)
    });
  }

  onGetAllCampaignManagersCompleted({ payload: campaignManagers }) {
    logger.debug("StatusStore:onGetAllCampaignManagers", "called... ", {
      campaignManagers
    });
    this.setState({
      campaignManagers
    });
  }

  onChangeDefaultOrganization() {
    logger.debug("StatusStore:onChangeDefaultOrganization", "called... ");

    this.setState({
      campaignList: null
    });
  }

  onResetCampaignList() {
    logger.debug("StatusStore:onResetCampaignList", "called... ");

    this.setState({
      campaignList: null
    });
  }
}
